import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { calcTableProps } from '@aytm/app/stats/page/question-views/cx/lib/table-utils'

import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import ItemsChart from '@aytm/app/stats/page/question-views/answer-variants/components/chart/Chart'
import ComboChart from '@aytm/app/stats/page/question-views/cx/components/chart/Chart'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

// Combo's chart surface: a chart over the items list of the level the scope points at. `chart`
// is the plain answer-variants chart and sizes itself; sunburst and treemap are the nested
// chart, which walks the whole answer tree and takes the fixed legacy height. Both are the
// question's own answer -- combo carries no tag list -- so the chart reads the marshalled bag
// straight through, and the list builds its rows from the scoped slice block.coffee resolved.
const ChartsView = ({ viewMode, components, answer, chartHeight, chartProps, tableProps }) => {
  const isPlain = 'chart' === viewMode

  const Chart = isPlain ? ItemsChart : ComboChart
  const height = isPlain ? chartHeight : undefined

  // the payload sentinel is the raw answer, so the view decides its own loading state
  const isLoading = 'loading' === answer

  return (
    <>
      {isComponentOn(components, 'chart') &&
        !isNoneChartMode(chartProps?.questionChartMode, chartProps?.globalChartMode) && (
          <ChartPlaceholder height={height} isLoading={isLoading}>
            <Chart {...chartProps} />
          </ChartPlaceholder>
        )}
      {isComponentOn(components, 'table') && <Table {...calcTableProps(tableProps || {})} />}
    </>
  )
}

ChartsView.displayName = 'CxChartsView'

ChartsView.propTypes = {
  viewMode: PropTypes.string.isRequired,
  components: PropTypes.object,
  answer: answerPropType,
  chartHeight: PropTypes.number,
  chartProps: PropTypes.object,
  tableProps: PropTypes.object
}

export default ChartsView
